import React from "react";

const PricingContent = [
  {
    packName: "NKYC4",
    price: "212 triệu",
    packageFor: "Gói nâng cao 1",
    icon: "38",
    billCycle: "Billed per agent",
    preFeatures: [
      "Sử dụng 20.000 requests",
      "Tiết kiệm 21% chi phí trên 1 request",
      "Cung cấp API/SDK NFC đọc thẻ chip",
      "Xác thực CCCD gắn chip chính xác 100% với RAR-C06",
      "Hỗ trợ dịch vụ thường xuyên"
    ],
  },
  {
    packName: "NKYC5",
    price: "440 triệu",
    packageFor: "Gói nâng cao 2",
    icon: "40",
    billCycle: "Billed per agent",
    preFeatures: [
      "Sử dụng 50.000 requests",
      "Tiết kiệm 24% chi phí trên 1 request",
      "Cung cấp API/SDK NFC đọc thẻ chip",
      "Xác thực CCCD gắn chip chính xác 100% với RAR-C06",
      "Hỗ trợ dịch vụ thường xuyên"
    ],
  },
  {
    packName: "NKYC6",
    price: "700 triệu",
    packageFor: "Gói nâng cao 3",
    icon: "41",
    billCycle: "Billed per agent",
    preFeatures: [
      "Sử dụng 100.000 requests",
      "Tiết kiệm 33% chi phí trên 1 request",
      "Cung cấp API/SDK NFC đọc thẻ chip",
      "Xác thực CCCD gắn chip chính xác 100% với RAR-C06",
      "Hỗ trợ dịch vụ thường xuyên"
    ],
  },
  {
    packName: "NKYC7",
    price: "2.150 triệu",
    packageFor: "Gói nâng cao 4",
    icon: "41",
    billCycle: "Billed per agent",
    preFeatures: [
      "Sử dụng 300.000 requests",
      "Tiết kiệm 38% chi phí trên 1 request",
      "Cung cấp API/SDK NFC đọc thẻ chip",
      "Xác thực CCCD gắn chip chính xác 100% với RAR-C06",
      "Hỗ trợ dịch vụ thường xuyên"
    ],
  },
];

const PricingYearly = () => {
  return (
    <div className="row justify-content-center">
      {PricingContent.map((val, i) => (
        <div className="col-lg-6 col-md-6" key={i}>
          <div className="pr-table-wrapper" style={{marginBottom:30}}>
            <div className="pack-name">{val.packName}</div>
            <div className="price font-rubik">
              {val.price} VNĐ
            </div>
            <div className="pack-rec font-rubik">{val.packageFor}</div>
            <img
              src={`images/icon/${val.icon}.svg`}
              alt="icon"
              className="icon"
            />
            <div className="bill-cycle">Billed per agent</div>
            <ul className="pr-feature">
              {val.preFeatures.map((list, i) => (
                <li key={i}>{list}</li>
              ))}
            </ul>
            <a href="#" className="theme-btn-four">
              Liên hệ
            </a>
          </div>
          {/*  /.pr-table-wrapper */}
        </div>
      ))}
    </div>
  );
};

export default PricingYearly;
